import type { InventorySlot } from "@ghostland/shared";

export interface StorageState {
  slots: InventorySlot[];
  capacity: number;
  tier: number;
  upgradeCost: number | null;
}

type Listener = (s: StorageState) => void;

/**
 * Client mirror of the player's BANK VAULT storage (an upgradable second inventory). Fed by the
 * server's targeted `Storage` messages; the storage panel subscribes. The server is authoritative.
 */
class StorageStore {
  private state: StorageState = { slots: [], capacity: 0, tier: 0, upgradeCost: null };
  private readonly listeners = new Set<Listener>();

  get(): StorageState { return this.state; }

  set(s: StorageState): void {
    this.state = s;
    for (const fn of this.listeners) fn(this.state);
  }

  subscribe(fn: Listener): () => void {
    this.listeners.add(fn);
    fn(this.state);
    return () => this.listeners.delete(fn);
  }
}

export const storageStore = new StorageStore();
